import { octaChat, demia } from '@/utils/chat-widgets'
import { clientService } from '@/services/client-service'

const DEMIA = 'demia'
const OCTADESK = 'octadesk'
const OCTA_PERSON_DOMAIN_TYPE = 2
const OCTA_COMPANY_FIELD_ID = 'empresa'

function isAutoLoginEnabled() {
  return process.env.VUE_APP_OCTADESK_AUTO_LOGIN === 'true'
}

async function buildCompanyFields(clientCode) {
  if (!clientCode) return []

  try {
    const { data } = await clientService.getByCode(clientCode)
    if (!data?.name) return []

    return [
      {
        id: OCTA_COMPANY_FIELD_ID,
        value: data.name,
        domainType: OCTA_PERSON_DOMAIN_TYPE
      }
    ]
  } catch (error) {
    return []
  }
}

const state = {
  activeChat: null,
  octaLoginKey: null
}

const mutations = {
  SET_ACTIVE_CHAT(state, chat) {
    state.activeChat = chat
  },
  SET_OCTA_LOGIN_KEY(state, key) {
    state.octaLoginKey = key
  }
}

const getters = {
  isLogisticaAmbevEcosystem(state, getters, rootState) {
    return rootState.user.userEcosystems.some(eco => eco._id === process.env.VUE_APP_LOGISTICA_AMBEV_ECOSYSTEM_ID)
  },
  ecosystemReference(state, getters, rootState) {
    const ecosystems = rootState.user.userEcosystems
    if(!ecosystems?.length) {
      return null
    }

    const ecosystem = ecosystems.find(eco => eco._id === process.env.VUE_APP_LOGISTICA_AMBEV_ECOSYSTEM_ID)
    if(ecosystem) {
      return ecosystem._id
    }

    return ecosystems[0]._id
  },
  identityReference(state, getters, rootState) {
    return `${rootState.user.userClient}:${getters.ecosystemReference}`
  }
}

const actions = {
  async applyStrategy({ commit, state, rootGetters, getters, dispatch }) {
    if (!rootGetters.userClient) return
    const target = getters.isLogisticaAmbevEcosystem ? DEMIA : OCTADESK
    if (target === DEMIA) {
      demia.setUser({
        nome: rootGetters.name,
        email: rootGetters.userEmail,
        empresa: 'logisticaambev'
      })
      demia.load()
      octaChat.hide()
    } else {
      demia.cleanup()
      await dispatch('autoLoginOctaChat')
      octaChat.show()
    }
    commit('SET_ACTIVE_CHAT', target)
  },
  async autoLoginOctaChat({ commit, state, rootGetters }) {
    if (!isAutoLoginEnabled()) return

    const name = rootGetters.name
    const email = rootGetters.userEmail
    const clientCode = rootGetters.userClient
    if (!name || !email) return

    const loginKey = `${email}|${clientCode}`
    if (state.octaLoginKey === loginKey) return

    const customFields = await buildCompanyFields(clientCode)
    octaChat.login({ name, email, customFields })
    commit('SET_OCTA_LOGIN_KEY', loginKey)
  },
  hide({ state }) {
    if (state.activeChat === DEMIA) demia.cleanup()
    else octaChat.hide()
  },
  show({ state }) {
    if (state.activeChat === DEMIA) demia.restart()
    else octaChat.show()
  },
  toggle({ state }) {
    if (state.activeChat === DEMIA) demia.restart()
    else octaChat.toggle()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
